<div class="pool-breadcrumb" *ngIf="shouldShowBreadcrumb">
  <button
    class="back-arrow"
    icon="far fa-arrow-left"
    variant="muted"
    (click)="navigateToPoolsList()"
  ></button>
  <i class="far fa-slash-forward separator"></i>
  <ng-container *ngIf="poolName$ | async as poolName">
    <div
      class="pool-name"
      [pTooltip]="poolName"
      tooltipPosition="bottom"
      [showDelay]="1000"
    >
      {{ poolName }}
    </div>
  </ng-container>
  <i class="far fa-slash-forward separator"></i>
  <button class="page-selector" (mouseenter)="pageMenu.toggle($event)">
    {{ 'pool.navigation.' + currentPage | translate }}
    <i class="fas fa-caret-down"></i>
  </button>
  <p-overlayPanel #pageMenu styleClass="man-dropdown-menu">
    <div class="wrapper">
      <button class="menu-item" (click)="navigateToPage('questions')">
        {{ 'pool.navigation.questions' | translate }}
      </button>
      <button class="menu-item" (click)="navigateToPage('tasks')">
        {{ 'pool.navigation.tasks' | translate }}
      </button>
      <button class="menu-item" (click)="navigateToPage('exams')">
        {{ 'pool.navigation.exams' | translate }}
      </button>
    </div>
  </p-overlayPanel>
</div>
